<template>
    <div>
        <action-row>
            <el-button
            class="no-print"
            type="warning"
            icon="el-icon-printer"
            size="small"
            @click="printHandler"
            >
                打印/导出资格审查结果
            </el-button>
            <my-btn type="new" style=" margin-left: 5px;" @click="cqwt()">澄清问题</my-btn>
            <el-button v-if="isycxwsb" style="margin-left: 5px;" size="small" type="danger" @click="ycxwsb()"><i class="el-icon-warning el-icon--left"></i>异常行为识别</el-button>
        </action-row>

        <table-shen-cha :data="tableData" @view="viewHandler">
            <el-table-column label="不通过原因（不输入表示通过）" prop="by5"></el-table-column>
        </table-shen-cha>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import TableShenCha from './components/table-shen-cha'

export default {
    mixins: [ FORM_PAGE_MIXIN ],
    components: { TableShenCha },
    data: () => ({
        tableData: [],
        isycxwsb: false,
    }),                        
    methods: { 
        printHandler() {
            this.goto({
                path: './print',
                query: {
                  bdcode:this.getQuery('bdcode')
                }             
            });
        },
        cqwt() {
            this.goto({
                path: './cqwtlist',
                query: {
                  bdcode:this.getQuery('bdcode')
                }             
            });
        },
        ycxwsb() {
            window.open('http://hpb.hbidding.com/pingbiao/pbnode/disycxw?bdcode=' + this.getQuery('bdcode'),'_blank');
        },
        viewHandler(url) {
            console.log(url)
            window.open(url);
        }
    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/Zbdl/zgsc/xingtai/detail.json`,{bdcode:this.getQuery('bdcode')}, data => {
            console.log(data)
            this.tableData = data.listData;
            if (data.isycxwsb === '1') {
                this.isycxwsb = true;
            }
            this.jspDataInit(data, []);
        });
    }
}
</script>

<style scoped lang="scss">

</style>
